import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Input, DatePicker, Select, Row, Col, Card } from 'antd';
import axios from 'axios';
import moment from 'moment';
import { workingDaysCount, holidaysListInDateRange } from './leaveUtil';
import { fetchHolidays } from './LeaveService';
import { getLeaveType } from '../../components/LeaveType/LeaveTypeService'
  
const API_HOST_URL = process.env.REACT_APP_API_URL

  const LeaveRequestDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line

    
    class extends React.Component {

      state = {
        leaveTypes: [],
        fromDateSelected: {},
        toDateSelected: {},
        noOfDaysMessage: '',
        holidaysInLeaveRequestDateRange: [],
        numberOfHolidays: 0,
        numberOfWorkingDays: 0
      }

      componentDidMount(){
        this.fetchLeaveTypes();
      }

      fetchLeaveTypes = () => {
        axios.get(`${API_HOST_URL}/api/leave/leavetype/leaveType_balance_days/?employee_id=${this.props.loggedInEmployee.id}`)
          .then(res => {
            this.setState({
              leaveTypes: res.data
            })
          })
      }

      extraMessage = () => {
        let noOfWorkingDays = this.state.numberOfWorkingDays;
        return noOfWorkingDays !== undefined ? '(' + noOfWorkingDays + (noOfWorkingDays>1?' days':' day') + ')' : ''
      }

      handleSelectChange = async(value) => {
          console.log(value);
          this.props.form.setFieldsValue({
            leaveType:  value
          });
          
          // do this if the from, to dates were selected before the leave type
          if(this.state.fromDateSelected._isAMomentObject == true && this.state.toDateSelected._isAMomentObject == true){

            //consider calendar days for leave types where weekends and holidays are counted
           //get to check whether leave type counts weekends or holidays
            const selectedLeaveTypeId = value;
            const leaveType = await getLeaveType(selectedLeaveTypeId);
 
             console.log("Selected leave type object: ", leaveType);
 
             if(leaveType.countWeekends === true && leaveType.countHolidays === true){
                const workingDays = moment(this.state.toDateSelected).diff(this.state.fromDateSelected, 'days') + 1;
                this.setState({
                  numberOfWorkingDays: workingDays,
                  holidaysInLeaveRequestDateRange: []
                })
              } else {
             fetchHolidays().then(result => {//result is list of holidays from backend
               console.log("result_holidays: ", result);
               const workingDays = workingDaysCount(this.state.fromDateSelected, this.state.toDateSelected, result);
               const holidaysList = holidaysListInDateRange(this.state.fromDateSelected, this.state.toDateSelected, result);
               this.setState({
                   numberOfWorkingDays: workingDays,
                   holidaysInLeaveRequestDateRange: holidaysList
               })
               
             })
           }
       }
      }

      range = (start, end) => {
        const result = [];
        for (let i = start; i < end; i++) {
          result.push(i);
        }
        return result;
      }
      

      fromDisabledDate = (current) => {
        // Can not select days before today and today
        return current < moment().add(-1,'day');
        
      }

      toDisabledDate = (current) => {
        // Can not select days before today and today
        if(this.state.fromDateSelected._isAMomentObject){
          return current < this.state.fromDateSelected.add(-1,'day');
        }
        
      }
      
      disabledDateTime =() => {
        return {
          disabledHours: () => [0,1,2,3,4,5,6,7,18,19,20,21,22,23],
          // disabledHours: () => this.range(0, 24).splice(0, 8),
          disabledMinutes: () => this.range(1, 60),
          disabledSeconds: () => this.range(1,60),
        };
      }

      fromDateChange = (dateMoment) => {
        
        // console.log(dateMoment, dateString)
        this.setState({
          fromDateSelected: dateMoment
        },
        //this callback ensures to wait for setState operation to finish before it execures.
        async()=>{
          console.log("fromDate state: ", this.state.fromDateSelected)
          
          //consider calendar days for leave types where weekends and holidays are counted
          if(this.state.fromDateSelected._isAMomentObject == true && this.state.toDateSelected._isAMomentObject == true){

            //consider calendar days for leave types where weekends and holidays are counted
          //get to check whether leave type counts weekends or holidays
          const selectedLeaveTypeId = this.props.form.getFieldValue('leaveType');
          if(selectedLeaveTypeId !== undefined){
            const leaveType = await getLeaveType(selectedLeaveTypeId);

            console.log("Selected leave type object: ", leaveType);

            if(leaveType.countWeekends === true && leaveType.countHolidays === true){
            const workingDays = moment(this.state.toDateSelected).diff(this.state.fromDateSelected, 'days') + 1;
            this.setState({
              numberOfWorkingDays: workingDays,
              holidaysInLeaveRequestDateRange: []
            })
          } else {
            fetchHolidays().then(result => {//result is list of holidays from backend
              const workingDays = workingDaysCount(this.state.fromDateSelected, this.state.toDateSelected, result);
              const holidaysList = holidaysListInDateRange(this.state.fromDateSelected, this.state.toDateSelected, result);
              this.setState({
                  numberOfWorkingDays: workingDays,
                  holidaysInLeaveRequestDateRange: holidaysList
              })
            })
          }
          } else {
              fetchHolidays().then(result => {//result is list of holidays from backend
                const workingDays = workingDaysCount(this.state.fromDateSelected, this.state.toDateSelected, result);
                const holidaysList = holidaysListInDateRange(this.state.fromDateSelected, this.state.toDateSelected, result);
                this.setState({
                    numberOfWorkingDays: workingDays,
                    holidaysInLeaveRequestDateRange: holidaysList
                })
              })
            }
          }
      }
      )
    }

    
    toDateChange = (dateMoment) =>{
      // console.log(dateMoment, dateString)
      this.setState({
        toDateSelected: dateMoment
      },
      //this callback ensures to wait for setState operation to finish before it execures.
      async()=>{
      
        //check to see that from and to dates are in the state. by checkiong if they are moment objects
        console.log("ToDate state: ", this.state.toDateSelected)
        if(this.state.fromDateSelected._isAMomentObject == true && this.state.toDateSelected._isAMomentObject == true){

           //consider calendar days for leave types where weekends and holidays are counted
          //get to check whether leave type counts weekends or holidays
          const selectedLeaveTypeId = this.props.form.getFieldValue('leaveType');
          if(selectedLeaveTypeId !== undefined){
            const leaveType = await getLeaveType(selectedLeaveTypeId);

            console.log("Selected leave type object: ", leaveType);

            if(leaveType.countWeekends === true && leaveType.countHolidays === true){
            const workingDays = moment(this.state.toDateSelected).diff(this.state.fromDateSelected, 'days') + 1;
            this.setState({
              numberOfWorkingDays: workingDays,
              holidaysInLeaveRequestDateRange: []
            })
          } else {
            fetchHolidays().then(result => {//result is list of holidays from backend
              const workingDays = workingDaysCount(this.state.fromDateSelected, this.state.toDateSelected, result);
              const holidaysList = holidaysListInDateRange(this.state.fromDateSelected, this.state.toDateSelected, result);
              this.setState({
                  numberOfWorkingDays: workingDays,
                  holidaysInLeaveRequestDateRange: holidaysList
              })
            })
          }
          } else {
            fetchHolidays().then(result => {//result is list of holidays from backend
              console.log("result_holidays: ", result);
              const workingDays = workingDaysCount(this.state.fromDateSelected, this.state.toDateSelected, result);
              const holidaysList = holidaysListInDateRange(this.state.fromDateSelected, this.state.toDateSelected, result);
              this.setState({
                  numberOfWorkingDays: workingDays,
                  holidaysInLeaveRequestDateRange: holidaysList
              })
              
            })
          }
      }
    }
    )

     
    }

        
      render() {
        const { visible, onCancel, onCreate, form, data, confirmLoading} = this.props;
        const { getFieldDecorator } = form;

        const { Option } = Select;
        const { TextArea } = Input;

        return (
          <Modal
            visible={visible}
            title="Apply for Leave"
            okText="Apply"
            onCancel={onCancel}
            onOk={onCreate}
            confirmLoading={confirmLoading}>

            <Form >
              <Row >
                <Col span={24} style={{ padding: 8}}>
                  <Form.Item label="Leave Type">
                    {getFieldDecorator('leaveType', {
                      rules: [{ required: true, message: 'Please select leave type!' }],
                    })(
                      <Select
                        placeholder="Select Leave Type"
                        onChange={this.handleSelectChange}
                      >
                      {
                        this.state.leaveTypes.map(leaveType => 
                        <Option key={leaveType.id} value={ leaveType.id}>{ leaveType.leaveType + ' ('+ leaveType.leaveBalanceAmount + (leaveType.leaveBalanceAmount>1?' days':' day') +')' }</Option>
                      )
                      }
                      </Select>
                    )}
                </Form.Item>
                </Col>
              </Row>
            <Row style={{ marginBottom: 0 }}>
                <Col span={12} style={{ padding: 8}}>
                  <Form.Item 
                      label="From"
                      extra={this.extraMessage()}>
                      {getFieldDecorator('fromDate', {
                        // initialValue: data.fromDate,
                        // initialValue: moment(data.toDate).format('DD/MM/YYYY HH:mm'),
                        rules: [{ type: 'object', required: true, message: 'Please select date!' }],
                      })( <DatePicker 
                        // showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                        format="YYYY-MM-DD"
                        // disabledDate={this.fromDisabledDate}
                        // disabledTime={this.disabledDateTime} 
                        onChange={this.fromDateChange}
                        /> 
                      )}
                  </Form.Item>
                </Col>
                <Col span={12} style={{ padding: 8}}>
                  <Form.Item 
                    label="To">
                    {getFieldDecorator('toDate', {
                      // initialValue: data.fromDate,
                      // initialValue: moment(data.toDate).format('DD/MM/YYYY HH:mm'),
                      rules: [{ type: 'object', required: true, message: 'Please select date!' }],
                    })( <DatePicker 
                      // showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                    format="YYYY-MM-DD"
                    // disabledDate={this.toDisabledDate}
                    // disabledTime={this.disabledDateTime} 
                    onChange={this.toDateChange}
                    /> 
                  )}
                </Form.Item>
                </Col>
            </Row>

            { this.state.holidaysInLeaveRequestDateRange.length > 0 &&
              <Row style={{ marginTop: 2, marginBottom: 2 }}>
              <Col span={24} style={{ padding: 8}}>
                    <Card>
                      <p style={{color: 'grey'}}>{this.state.holidaysInLeaveRequestDateRange.length > 1 ?'There are some holidays':'There is a holiday'} in between, <span style={{fontWeight: 'bold'}}>{moment(this.state.fromDateSelected).format('ll')} </span> and <span style={{fontWeight: 'bold'}}>{moment(this.state.toDateSelected).format('ll')}</span>:</p>
                      <ul>
                      {
                        this.state.holidaysInLeaveRequestDateRange.map((item, index)=> (   
                          <li key={index}> <span style={{color: '#1890ff'}}>{moment(item.holidayDate).format('ddd, MMM Do, YYYY')} </span>- <span style={{color: 'grey', fontStyle: 'italic'}}>{item.holidayName}</span></li>
                        ))
                      }
                      </ul>
                    </Card>
                  </Col>
              </Row>
            }

              <Form.Item label="Reason">
                {getFieldDecorator('note', {
                 initialValue: data.note,
                  rules: [{ required: true, message: 'Kindly provide a reason for leave.' }],
                })( <TextArea /> )}
              </Form.Item>

            </Form>

          </Modal>
        );
      }
    }
  );

  const mapStateToProps = state => {
    return {
      isAuthenticated: state.token !== null,
      loggedInEmployee: state.loggedInEmployee,
      userPermissions: state.userPermissions
    }
  }
  
  export default connect(mapStateToProps, null)(LeaveRequestDialogForm);
  // export default LeaveRequestDialogForm;
